import { Badge } from "V2.0/common/badge";
import { Tooltip } from "antd";
import { Table, TableBody, TableRow, TableCell } from "V2.0/common/table";

enum WebhookStatus {
  FINISHED = "finished",
  FAILED = "failed",
  ERROR = "error",
}

interface WebhookUpdate {
  webhookStatus: WebhookStatus;
  responseStatus: string;
  webhookId: string;
  webhookListId: string;
  webhookName: string;
  webhookUrl: string;
}

const badgeColor = {
  [WebhookStatus.FINISHED]: "green",
  [WebhookStatus.FAILED]: "red",
  [WebhookStatus.ERROR]: "red",
};

function getStatusColor(statusCode) {
  if (statusCode >= 100 && statusCode < 200) {
    return "zinc";
  } else if (statusCode >= 200 && statusCode < 300) {
    return "green";
  } else if (statusCode >= 300 && statusCode < 400) {
    return "blue";
  } else if (statusCode >= 400 && statusCode < 500) {
    return "red";
  } else if (statusCode >= 500 && statusCode < 600) {
    return "red";
  } else {
    return "zinc";
  }
}

export default function WebhookUpdates(props) {
  const { webhookUpdates } = props;

  if (!webhookUpdates || webhookUpdates.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col gap-y-2 mx-2">
      <p className="text-sm text-gray-500">Logs ({webhookUpdates.length})</p>
      <div className="border-b" />
      <div className="max-h-[250px] overflow-scroll">
        <Table>
          <TableBody>
            {webhookUpdates.map((webhook, idx) => {
              return (
                <TableRow key={idx}>
                  <TableCell>
                    <div>
                      <div className="flex gap-x-2">
                        <p className="text-sm text-gray-500">
                          {webhook.webhookName}
                        </p>
                      </div>
                      <div>
                        <p className="text-gray-500 truncate max-w-48 hover:cursor-pointer">
                          <Tooltip title={webhook.webhookUrl}>
                            {webhook.webhookUrl}
                          </Tooltip>
                        </p>
                      </div>
                    </div>
                  </TableCell>
                  <TableCell>
                    <Badge
                      color={getStatusColor(Number(webhook.responseStatus))}
                    >
                      {webhook.responseStatus}
                    </Badge>
                  </TableCell>
                  <TableCell>
                    <Badge color={badgeColor[webhook.webhookStatus]}>
                      {webhook.webhookStatus}
                    </Badge>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
